import React, { useMemo } from 'react'

import { TextField } from '@barracuda-internal/bds-core'

import { HelperText } from 'components/libs/layout/pages/HelperText'
import { useIsReadonly } from 'lib/hooks/useIsReadonly'

export type InlineInputFieldProps = {
  name: string
  inputClassName?: string
  helperText?: string
  value: any
  onChange: (newValue: any) => void
  disabled?: boolean
  placeholder?: string
  error?: boolean
  rows?: number
}

export const InlineInputField = ({
  name,
  inputClassName,
  helperText,
  value,
  onChange,
  disabled,
  placeholder,
  error,
  rows = 1
}: InlineInputFieldProps) => {
  const isReadonly = useIsReadonly()

  return useMemo(
    () => (
      <>
        <TextField
          className={`${inputClassName}`}
          value={value}
          onChange={onChange}
          disabled={isReadonly || disabled}
          name={name}
          error={error}
          size="small"
          data-testid={`input:${name}`}
          placeholder={placeholder}
          minRows={rows}
          maxRows={rows}
          {...(rows > 1 ? { multiline: true } : { fullWidth: true })}
        />
        {!!helperText && <HelperText error={error}>{helperText}</HelperText>}
      </>
    ),
    [inputClassName, value, onChange, isReadonly, disabled, name, error, placeholder, rows, helperText]
  )
}
